import React from "react";
import "./AshtavinayakPackage.css";

const itinerary = [
  {
    day: "Day 1",
    places: [
      "Pune",
      "Morgaon",
      "Siddhatek",
      "Theur",
      "Ranjangaon",
      "Ozar",
    ],
    stay: "Night Stay – Ozar",
  },
  {
    day: "Day 2",
    places: [
      "Ozar",
      "Lenyadri",
      "Mahad",
      "Pali",
      "Pune",
    ],
    stay: "Return to Pune",
  },
];

const vehicles = [
  {
    name: "Sedan Cab",
    price: "₹11,000",
    icon: "🚘",
  },
  {
    name: "Ertiga Cab",
    price: "₹13,500",
    icon: "🚙",
  },
  {
    name: "Kia Carens",
    price: "₹15,900",
    icon: "🚗",
  },
  {
    name: "Innova Crysta",
    price: "₹17,500",
    icon: "🚐",
    popular: true,
  },
];

export default function AshtavinayakPackage() {
  return (
    <section className="ml-package">
      <div className="ml-container">

        {/* HEADER */}
        <div className="ml-header">
          <div className="ml-logo-box">
            <img
              src="/images/logo.jpg"
              alt="Garud Cabs"
              className="ml-logo"
            />
          </div>

          <div className="ml-header-content">
            <span className="ml-badge">
              1 Night • 2 Days
            </span>

            <h1>
              Pune to Ashtavinayak
              <span> Darshan Package</span>
            </h1>

            <p>
              Complete Ashtavinayak Darshan from Pune covering all
              eight sacred Ganpati temples with comfortable Commercial 
              cab travel by Garud Cabs.
            </p>
          </div>
        </div>

        {/* ROUTE */}
        <div className="ml-route">
          <span className="ml-route-label">
            COMPLETE DARSHAN ROUTE
          </span>

          <div className="ml-route-text">
            Pune <b>→</b> Morgaon <b>→</b> Siddhatek
            <b> → </b> Theur <b>→</b> Ranjangaon
            <b> → </b> Ozar <b>→</b> Lenyadri
            <b> → </b> Mahad <b>→</b> Pali
            <b> → </b> Pune
          </div>
        </div>

        {/* MAIN SECTION */}
        <div className="ml-main-grid">

          {/* ITINERARY */}
          <div className="ml-card ml-itinerary">

            <div className="ml-section-title">
              <div className="ml-number">02</div>

              <div>
                <small>ASHTAVINAYAK DARSHAN PLAN</small>
                <h2>2-Day Itinerary</h2>
              </div>
            </div>

            <div className="ml-timeline">
              {itinerary.map((item, index) => (
                <div
                  className="ml-timeline-item"
                  key={item.day}
                >
                  <div className="ml-day-number">
                    {index + 1}
                  </div>

                  <div className="ml-day-content">
                    <h3>{item.day}</h3>

                    <div className="ml-places">
                      {item.places.map((place, i) => (
                        <React.Fragment key={place}>
                          <span>{place}</span>

                          {i !== item.places.length - 1 && (
                            <b>→</b>
                          )}
                        </React.Fragment>
                      ))}
                    </div>

                    <div className="ml-stay">
                      🏨 {item.stay}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="ml-side">

            {/* INCLUDED */}
            <div className="ml-card ml-included">
              <span className="ml-small-label">
                ALL-INCLUSIVE PACKAGE
              </span>

              <h2>Everything Included</h2>

              <div className="ml-included-grid">
                <div>✓ Fuel Charges</div>
                <div>✓ Toll Charges</div>
                <div>✓ Parking Charges</div>
                <div>✓ Driver Allowance</div>
                <div>✓ Driver Food</div>
                <div>✓ Complete Cab Charges</div>
              </div>

              <div className="ml-inclusive-note">
                ✓ No Extra Transportation Charges
              </div>
            </div>

            {/* DARSHAN DETAILS */}
            <div className="ml-card ml-tour-info">
              <h3>🙏 Ashtavinayak Darshan</h3>

              <div className="ml-info-row">
                <span>Ganpati Temples</span>
                <strong>8 Temples</strong>
              </div>

              <div className="ml-info-row">
                <span>Tour Duration</span>
                <strong>1 Night / 2 Days</strong>
              </div>

              <div className="ml-info-row">
                <span>Starting Point</span>
                <strong>Pune</strong>
              </div>

              <div className="ml-info-row">
                <span>Night Stay</span>
                <strong>Ozar</strong>
              </div>

              <div className="ml-info-row">
                <span>Tour Type</span>
                <strong>Commercial Cab</strong>
              </div>
            </div>

            <div className="ml-package-note">
              <strong>
                Complete Ashtavinayak Darshan Package
              </strong>

              <p>
                Travel comfortably to all eight Ashtavinayak
                Ganpati temples with an experienced driver and
                complete transportation arrangements.
              </p>
            </div>
          </div>
        </div>

        {/* PRICING */}
        <div className="ml-pricing">

          <div className="ml-pricing-head">
            <div>
              <span className="ml-small-label">
                CHOOSE YOUR CAB
              </span>

              <h2>Ashtavinayak Package Price</h2>
            </div>

            <p>
              Complete 1 Night / 2 Days Darshan
            </p>
          </div>

          <div className="ml-vehicle-grid">

            {vehicles.map((vehicle) => (
              <div
                className={`ml-vehicle-card ${
                  vehicle.popular ? "ml-popular" : ""
                }`}
                key={vehicle.name}
              >
                {vehicle.popular && (
                  <span className="ml-popular-tag">
                    POPULAR
                  </span>
                )}

                <div className="ml-vehicle-icon">
                  {vehicle.icon}
                </div>

                <div className="ml-vehicle-info">
                  <h3>{vehicle.name}</h3>
                  <small>
                    All-Inclusive Package
                  </small>
                </div>

                <div className="ml-price">
                  {vehicle.price}
                </div>
              </div>
            ))}

          </div>
        </div>

        {/* BOOKING CTA */}
        <div className="ml-booking">

          <div>
            <span>GARUD CABS • PUNE</span>

            <h2>
              Book Your Ashtavinayak Darshan
            </h2>

            <p>
              8 Ganpati Temples • Commercial Cab •
              Experienced Driver • All-Inclusive Package
            </p>
          </div>

          <a
            href="tel:+919970007784"
            className="ml-book-btn"
          >
            Book Your Cab →
          </a>

        </div>

      </div>
    </section>
  );
}